import { useState } from 'react';

export const useSelection = <T = any>() => {
  const [selectedObj, setSelectedObj] = useState<T | null>(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState<string | null>(null);

  const handleRowClick = (params: any) => {
    setSelectedRowIndex(params.id);
    setSelectedObj(params.row);
  };

  const clearSelection = () => {
    setSelectedObj(null);
    setSelectedRowIndex(null);
  };

  return {
    selectedObj,
    setSelectedObj,
    selectedRowIndex,
    setSelectedRowIndex,
    handleRowClick,
    clearSelection
  };
};
